export interface CostItem {
  description: string;
  type: string;
  amount: number;
}

export interface CargoboardQuotation {
  loadingType?: LoadingUnloadingTypes;
  quotationId?: string;
  amount: number;
  currency: string;
  costItems: CostItem[];
}

export enum LoadingUnloadingTypes {
  PortableForklift = 'TRUCK_MOUNTED_FORKLIFT',
  HydraulicRamp = 'LIFTING_PLATFORM_OR_TAIL_LIFT_TRUCK',
  PalletTruck = 'LIFTING_PLATFORM_OR_TAIL_LIFT_TRUCK',
  Crane = 'CRANE',
  RearLoading = 'RAMP',
  SideLoading = 'SIDE',
}
